import React from 'react'
import './landing.css'
import sf from "./images/SFlogostyle.png"
import vd from "./images/vd.webm"
import sf_logo from './images/SF logo.png'
import iitkgp_logo from './images/kgp_logo.png'
const landing = () => {
    return (
        <div className='lpbody'>
            <div className="topbar">
        <a href="https://springfest.in/" target="_blank" className="logo_home" id="h1">
          <img src={sf_logo} />
        </a>
        <a href="http://www.iitkgp.ac.in/" target="_blank" className="logo_home" id="h2">
          <img src={iitkgp_logo} />
        </a>
        </div>
            <div className="lpcontainer">
                <div className="text-container">
                    <div className="springfest lp"><img src={sf} alt="Spring Fest" /></div>
                    <div className="presents lp">presents</div>
                    <div className="cause">
                    <div className="pukaar lp">Pukaar</div>
                    <div className="description lp">Fulfilling a silent demand</div>
                    </div>
                    <button className='donatelp'><a href="https://www.ketto.org/fundraiser/spreading-love-and-happiness-on-christmas-and-new-year" target={"_blank"}>Donate&#10084;</a></button>
                </div>
                <div className="video-container">
                    <video className='video' autoPlay muted loop>
                        <source src={vd} type='video/webm'/>
                    </video>
                </div>
            </div>
            <hr className='hr-tag margin'/>
        </div>
    );
}

export default landing;